import React from 'react';
import { Editor } from 'slate';
import { useSlate } from 'slate-react';
import { TextModifier } from 'types/comment';
import { EditorButton } from './EditorButton';
import { Icon } from './Icon';

const isMarkActive = (editor: Editor, format: TextModifier) => {
  const marks = Editor.marks(editor);
  return marks ? marks[format] === true : false;
};

const toggleMark = (editor: Editor, format: TextModifier) => {
  const isActive = isMarkActive(editor, format);

  if (isActive) {
    Editor.removeMark(editor, format);
  } else {
    Editor.addMark(editor, format, true);
  }
};

export const MarkButton = ({
  format,
  icon,
}: {
  format: TextModifier;
  icon: string;
}) => {
  const editor = useSlate();
  return (
    <EditorButton
      active={isMarkActive(editor, format)}
      onMouseDown={(event: React.MouseEvent<HTMLSpanElement>) => {
        event.preventDefault();
        toggleMark(editor, format);
      }}
    >
      <Icon>{icon}</Icon>
    </EditorButton>
  );
};
